// extracted by mini-css-extract-plugin
export var actionIcon = "_tw-0";